<template>

  <div>

    <t-dialog-form :title="title" :status="''" cancel-text="Limpar" :ok-text="okText"
                   :id="id" :command="'insert'" :large="bigSearch"
                   ref="dialog_form" @onSubmit="onSubmit" @onCancel="onClearSearch">

      <div class="p-2">

        <slot></slot>

        <!-- onPressEnter funcionará apenas para campos que não conflitam -->
        <t-page-form-field-customized
            v-if="fieldsCustom !== null"
            @onPressEnter="onSubmit"
            only-search :big-search="bigSearch"
            :fields-customizable="fieldsCustom"
        />

        <slot name="after-fields-custom"></slot>

        <t-input-search label="Status" v-if="searchForm.hasOwnProperty('status')" :options="statusOptions" select
                        v-model="searchForm.status"/>

      </div>
    </t-dialog-form>

    <div class="position-relative form-group">

      <div class="input-group-icon">


        <input
            type="text"
            style="max-width: 250px"
            :placeholder="placeholder"
            @keyup="onSearchDefault"
            v-model.trim="searchForm.default"
            class="form-control">

        <i class="input-icon pe-7s-search"
           style="font-size: 18px"></i>

        <div class="input-group-append" v-if="hasAdvancedFilter()"
             style="margin-left: -3px;margin-top: 0; scale: 0.95;">


          <t-button @click="openSearchDialog()" light class="btn-light" v-show="!filteredAdvanced" v-b-tooltip.hover.ds500 title="Pesquisa avançada">
            <b-icon-sliders></b-icon-sliders>
          </t-button>

          <t-button @click="openSearchDialog()" style="margin-left: 1px" v-show="filteredAdvanced" outline-primary v-b-tooltip.hover.ds500 title="Filtros aplicados">
            <b-icon-funnel></b-icon-funnel>
          </t-button>

        </div>

      </div>

    </div>

  </div>

</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";

export default {
  name: 't-content-header-search-default',
  components: {tDialogForm},
  props: {
    value: {
      type: null,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    bigSearch: Boolean,
    searchForm: {
      type: Object,
      required: true
    },
    filteredDefault: {
      type: Boolean,
      default: false,
    },
    filteredAdvanced: {
      type: Boolean,
      default: false,
    },
    fieldsCustom: {
      type: Array,
      default: null
    },
  },
  data() {
    return {
      id: "modal-advanced-search",
      title: "Filtro Avançado",
      okText: "Filtrar",
      statusOptions: [{value: 1, text: 'Ativos'}, {value: 2, text: 'Inativos'}],
    }
  },
  methods: {

    hasAdvancedFilter() {

      let hasAdvancedFilter = false

      Object.entries(this.searchForm).every(([key]) => {

        if (key !== 'default') {
          hasAdvancedFilter = true
          return false
        } else {
          return true
        }
      })

      return hasAdvancedFilter

    },

    onSearchDefault() {
      this.$emit('searchChange', this.searchForm.default)
    },

    onClearSearch() {
      this.$emit("onClearSearch")
    },

    openSearchDialog() {
      this.$bvModal.show(this.id)
    },

    async onSubmit() {

      this.$bvModal.hide(this.id)
      this.$emit('searchChange', this.searchForm.default)
    },


  },
  watch: {},
  /*computed: {
    search: {
      get: function () {
        return this.name
      },
      set: function (value) {
        this.$emit('searchChange', value)
      }
    }
  },*/

}
</script>
